/*  JS of Volume Pricing Snippet 
    Added by Wilson from Galadrim  */

document.addEventListener("DOMContentLoaded", () => {
  // --- Logic for the main product page (which has a form) ---
  const mainProductContainer = document.querySelector(".product--outer [data-volume-pricing-container]");

  if (mainProductContainer) {
    const productHandle = mainProductContainer.dataset.productHandle;
    const productForm = document.querySelector("form[data-product-form]");

    if (productForm && productHandle) {
      const quantityInput = productForm.querySelector('input[name="quantity"]');
      const variantSelector = document.querySelector("variant-selection");

      // Function to highlight current tier based on quantity (like in predictive search)
      const highlightCurrentTierOnProductPage = () => {
        if (!quantityInput || !variantSelector) return;

        const variantId = variantSelector.dataset.variant || mainProductContainer.dataset.initialVariantId;
        const grid = mainProductContainer.querySelector(`.b2b-pricing-grid[data-variant-id="${variantId}"]`);

        if (grid && typeof window.highlightCurrentTier === "function") {
          let cartQuantity = 0;

          try {
            // Fetch current cart data from API
            const cartData = Shopify.cart;

            // Calculate total cart quantity
            cartQuantity = cartData.items.reduce((total, item) => total + item.quantity, 0);
          } catch (error) {
            // Fallback: try to get from cart count element
            const cartCountElement = document.querySelector("[data-cart-count], .cart-count, .cart__count");
            if (cartCountElement) {
              cartQuantity = parseInt(cartCountElement.textContent || cartCountElement.innerText || "0", 10) || 0;
            }
          }

          // Get input quantity
          const inputQuantity = parseInt(quantityInput.value, 10) || 1;

          // Calculate total quantity (cart + input)
          const totalQuantity = cartQuantity + inputQuantity;

          // Update the highlighting
          window.highlightCurrentTier(grid, totalQuantity);
        }
      };

      const updateVolumeHighlighting = async () => {
        if (!quantityInput || !variantSelector) return;

        const variantId = variantSelector.dataset.variant || mainProductContainer.dataset.initialVariantId;
        const cartItems = window.Theme.cartItems || {};
        const cartQuantity = cartItems[variantId] || 0;
        const inputQuantity = parseInt(quantityInput.value, 10) || 1;
        const totalQuantity = cartQuantity + inputQuantity;

        // First, immediately highlight the current tier (like in predictive search)
        await highlightCurrentTierOnProductPage();

        // Then, optionally reload the full pricing grid for any server-side updates
        const url = `/products/${productHandle}?variant=${variantId}&section_id=volume-pricing-only&quantity=${totalQuantity}`;

        try {
          const response = await fetch(url);
          if (!response.ok) return;

          const text = await response.text();
          const newDoc = new DOMParser().parseFromString(text, "text/html");
          const newVolumePricing = newDoc.querySelector("[data-volume-pricing-container]");

          if (newVolumePricing) {
            mainProductContainer.innerHTML = newVolumePricing.innerHTML;
            // Re-highlight after HTML update
            setTimeout(async () => await highlightCurrentTierOnProductPage(), 50);
          }
        } catch (error) {
          console.error("Error updating volume pricing:", error);
        }
      };

      // Add immediate highlighting on quantity input changes (like in predictive search)
      const handleQuantityInputChange = async () => {
        await highlightCurrentTierOnProductPage();
      };

      // Add listeners for +/- buttons to immediately update highlighting
      const handleQuantityButtonClick = e => {
        if (e.target.matches("[data-quantity-plus]") || e.target.matches("[data-quantity-minus]")) {
          // Use setTimeout to let the input value update first
          setTimeout(async () => await highlightCurrentTierOnProductPage(), 10);
        }
      };

      if (quantityInput) {
        quantityInput.addEventListener("change", updateVolumeHighlighting);
        quantityInput.addEventListener("input", handleQuantityInputChange);
      }
      if (variantSelector) {
        variantSelector.addEventListener("change", updateVolumeHighlighting);
      }

      // Listen for clicks on +/- buttons within the product form
      productForm.addEventListener("click", handleQuantityButtonClick);

      // Initial highlighting on page load
      setTimeout(async () => await highlightCurrentTierOnProductPage(), 100);
    }
  }
});
